import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  filterEmailServer: []
}

const fetchEmailServerStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    records: action.records
  }
}

const fetchEmailServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    errorMessage: action.errorMessage
  }
}

const fetchEmailServerByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData
  }
}

const clearSelectedEmailServerRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createEmailServerStart = (state, action) => {
  return { ...state, loading: true }
}

const createEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createEmailServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateEmailServerStart = (state, action) => {
  return { ...state, loading: true }
}

const updateEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateEmailServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteEmailServerStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteEmailServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}
const fetchEmailServerFilterEmailServerStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchEmailServerFilterEmailServerSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterEmailServer: action.data
  }
}

const fetchEmailServerFilterEmailServerFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EMAIL_SERVER_START:
      return fetchEmailServerStart(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_SUCCESS:
      return fetchEmailServerSuccess(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_BY_ID_SUCCESS:
      return fetchEmailServerByIdSuccess(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_FAILED:
      return fetchEmailServerFailed(state, action)
    case actionTypes.CLEAR_SELECTED_EMAIL_SERVER_RECORD:
      return clearSelectedEmailServerRecord(state, action)
    case actionTypes.CREATE_EMAIL_SERVER_START:
      return createEmailServerStart(state, action)
    case actionTypes.CREATE_EMAIL_SERVER_SUCCESS:
      return createEmailServerSuccess(state, action)
    case actionTypes.CREATE_EMAIL_SERVER_FAILED:
      return createEmailServerFailed(state, action)
    case actionTypes.UPDATE_EMAIL_SERVER_START:
      return updateEmailServerStart(state, action)
    case actionTypes.UPDATE_EMAIL_SERVER_SUCCESS:
      return updateEmailServerSuccess(state, action)
    case actionTypes.UPDATE_EMAIL_SERVER_FAILED:
      return updateEmailServerFailed(state, action)
    case actionTypes.DELETE_EMAIL_SERVER_START:
      return deleteEmailServerStart(state, action)
    case actionTypes.DELETE_EMAIL_SERVER_SUCCESS:
      return deleteEmailServerSuccess(state, action)
    case actionTypes.DELETE_EMAIL_SERVER_FAILED:
      return deleteEmailServerFailed(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_START:
      return fetchEmailServerFilterEmailServerStart(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_SUCCESS:
      return fetchEmailServerFilterEmailServerSuccess(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_FAILED:
      return fetchEmailServerFilterEmailServerFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
